var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _ellipse, _path13, _path14, _ellipse2, _ellipse3, _path15, _ellipse4, _ellipse5, _path16, _path17, _path18, _circle, _circle2, _path19, _path20, _path21, _path22, _path23, _path24, _g, _rect, _rect2, _ellipse6, _ellipse7, _g2, _rect3, _rect4, _path25, _path26, _path27, _rect5, _path28, _path29, _circle3, _path30, _circle4, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThirdPartyBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 272,
    viewBox: "0 0 480 272",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M445.461 197.877C445.461 190.965 451.064 185.362 457.975 185.362C464.887 185.362 470.49 190.965 470.49 197.877V249.325H445.461V197.877Z",
    fill: "white",
    stroke: "#5B4542",
    strokeWidth: 0.556202
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M420.731 197.877C420.731 190.965 426.334 185.362 433.245 185.362C440.157 185.362 445.76 190.965 445.76 197.877V249.325H420.731V197.877Z",
    fill: "white",
    stroke: "#5B4542",
    strokeWidth: 0.556202
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M388.322 197.877C388.322 190.965 393.925 185.362 400.837 185.362C407.748 185.362 413.351 190.965 413.351 197.877V249.325H388.322V197.877Z",
    fill: "white",
    stroke: "#5B4542",
    strokeWidth: 0.556202
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M363.588 197.877C363.588 190.965 369.191 185.362 376.103 185.362C383.014 185.362 388.617 190.965 388.617 197.877V249.325H363.588V197.877Z",
    fill: "white",
    stroke: "#5B4542",
    strokeWidth: 0.556202
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M338.856 197.877C338.856 190.965 344.459 185.362 351.371 185.362C358.282 185.362 363.885 190.965 363.885 197.877V249.325H338.856V197.877Z",
    fill: "white",
    stroke: "#5B4542",
    strokeWidth: 0.556202
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M314.124 197.877C314.124 190.965 319.727 185.362 326.639 185.362C333.55 185.362 339.153 190.965 339.153 197.877V249.325H314.124V197.877Z",
    fill: "white",
    stroke: "#5B4542",
    strokeWidth: 0.556202
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M445.201 210.097C445.201 203.113 450.863 197.452 457.846 197.452C464.83 197.452 470.491 203.113 470.491 210.097V244.896H445.201V210.097Z",
    fill: "white",
    stroke: "#5B4542",
    strokeWidth: 0.556202
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M420.278 210.097C420.278 203.113 425.939 197.452 432.923 197.452C439.907 197.452 445.568 203.113 445.568 210.097V244.896H420.278V210.097Z",
    fill: "white",
    stroke: "#5B4542",
    strokeWidth: 0.556202
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M387.97 210.097C387.97 203.113 393.632 197.452 400.615 197.452C407.599 197.452 413.26 203.113 413.26 210.097V244.896H387.97V210.097Z",
    fill: "white",
    stroke: "#5B4542",
    strokeWidth: 0.556202
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M363.97 209.635C363.97 202.907 369.425 197.452 376.154 197.452C382.883 197.452 388.337 202.907 388.337 209.635V244.896H363.97V209.635Z",
    fill: "white",
    stroke: "#5B4542",
    strokeWidth: 0.556202
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M339.047 210.097C339.047 203.113 344.709 197.452 351.692 197.452C358.676 197.452 364.337 203.113 364.337 210.097V244.896H339.047V210.097Z",
    fill: "white",
    stroke: "#5B4542",
    strokeWidth: 0.556202
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M314.124 210.097C314.124 203.113 319.786 197.452 326.769 197.452C333.753 197.452 339.414 203.113 339.414 210.097V244.896H314.124V210.097Z",
    fill: "white",
    stroke: "#5B4542",
    strokeWidth: 0.556202
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 240,
    cy: 24.7482,
    rx: 240,
    ry: 24.7482,
    transform: "matrix(-1 0 0 1 480 219.901)",
    fill: "#E5F4FB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M86.308 108.11C86.308 92.8088 98.7124 80.4044 114.014 80.4044H152.872C185.952 80.4044 212.77 107.221 212.77 140.302V232.712H86.308V108.11Z",
    fill: "#FF8A6A",
    stroke: "#5B4542",
    strokeWidth: 0.923077
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9721 109.23C89.9721 95.4519 101.141 84.2827 114.919 84.2827H152.992C184.054 84.2827 209.234 109.463 209.234 140.524V227.57H89.9721V109.23Z",
    fill: "white",
    stroke: "#5B4542",
    strokeWidth: 0.866735
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 179.632,
    cy: 131.42,
    rx: 2.4006,
    ry: 3.2008,
    fill: "#5B4542"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 194.115,
    cy: 131.42,
    rx: 2.4006,
    ry: 3.2008,
    fill: "#5B4542"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M140.637 187.347C140.637 236.333 108.649 236.333 69.1901 236.333C29.731 236.333 16.3204 228.315 16.3204 187.347C16.3204 171.579 18.4646 154.431 20.7494 146.523C21.8587 142.684 25.8469 135.452 27.6046 133.08C35.2214 122.799 51.1828 113.168 69.1901 113.168C108.649 113.168 140.637 146.379 140.637 187.347Z",
    fill: "url(#paint0_linear_5003_9813)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 107.65,
    cy: 162.325,
    rx: 1.38895,
    ry: 3.47238,
    fill: "#5B4542"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 117.376,
    cy: 162.325,
    rx: 1.38895,
    ry: 3.47238,
    fill: "#5B4542"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M115.217 127.507C111.381 137.102 94.1093 147.977 83.8742 137.743C76.7236 130.594 88.9918 123.029 92.828 130.066C95.1754 134.372 95.8657 146.075 87.0727 156.293C79.4432 165.159 65.263 170.945 60.2058 165.888C50.6105 156.293 65.3233 148.617 68.5217 157.572C74.8787 175.372 34.1545 188.404 14.7699 180.558",
    stroke: "#5B4542",
    strokeWidth: 3.01795,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M277.387 165.789C277.757 148.07 287.54 142.404 292.617 141.789L294.001 145.943C288.001 145.943 281.54 154.251 281.54 165.789C281.54 213.82 271.847 215.635 262.154 219.789C257.847 218.251 254.355 217.579 264.002 213.789C276.924 208.712 276.924 187.943 277.387 165.789Z",
    fill: "white",
    stroke: "#5B4542",
    strokeWidth: 0.923077
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M206.993 143.983C204.637 141.378 200.309 143.045 200.309 146.558L200.31 155.784C200.31 155.785 200.309 155.785 200.309 155.785C200.309 155.785 200.308 155.785 200.308 155.786V226.151C200.308 238.869 210.619 249.179 223.337 249.179H241.248C253.967 249.179 264.277 238.869 264.277 226.151V182.65V180.091V176.893C264.277 175.614 264.056 175.137 263.637 173.401C261.203 163.294 252.103 155.785 241.248 155.785H229.142C221.838 155.785 214.876 152.695 209.976 147.279L206.993 143.983Z",
    fill: "url(#paint1_linear_5003_9813)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 238.416,
    cy: 192.827,
    r: 7.67625,
    stroke: "#5B4542",
    strokeWidth: 3.01795,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 261.451,
    cy: 192.824,
    r: 7.67625,
    stroke: "#5B4542",
    strokeWidth: 3.01795,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M230.392 164.32C234.273 164.32 234.162 160.482 238.154 160.482C243.143 160.482 242.035 164.32 247.024 164.32C252.014 164.32 251.459 160.482 255.34 160.482C259.221 160.482 259.775 164.32 263.656 164.32",
    stroke: "#5B4542",
    strokeWidth: 3.01795,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M302.787 127.505C302.975 126.94 303.504 126.558 304.1 126.558H324.208C325.154 126.558 325.821 127.484 325.522 128.381L317.522 152.381C317.334 152.946 316.804 153.327 316.208 153.327H296.1C295.155 153.327 294.488 152.402 294.787 151.505L302.787 127.505Z",
    stroke: "#5B4542",
    strokeWidth: 0.923077
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M304.154 127.02L312.462 139.02L295.385 152.866",
    stroke: "#5B4542",
    strokeWidth: 0.923077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M310.154 135.327L324.924 127.02",
    stroke: "#5B4542",
    strokeWidth: 0.923077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M309.231 141.789L317.077 152.866",
    stroke: "#5B4542",
    strokeWidth: 0.923077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M290.972 139.976C293.697 136.215 301.592 138.462 301.592 140.728C301.592 143.354 298.948 144.308 296.77 144.558L295.386 148.251C292.662 147.498 287.702 144.489 290.972 139.976Z",
    fill: "url(#paint2_linear_5003_9813)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5003_9813)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 150.72,
    y: 170.569,
    width: 5.1175,
    height: 11.5144,
    rx: 2.55875,
    fill: "url(#paint3_linear_5003_9813)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.181,
    y: 171.03,
    width: 4.19442,
    height: 10.5913,
    rx: 2.09721,
    stroke: "#5B4542",
    strokeWidth: 0.923077
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 103.888,
    y: 180.023,
    width: 74.4771,
    height: 68.0803,
    rx: 11.5688,
    fill: "white",
    stroke: "#5B4542",
    strokeWidth: 1.00598
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 117.919,
    y: 179.981,
    width: 74.56,
    height: 68.1632,
    rx: 11.6103,
    fill: "#FED4C7",
    stroke: "#5B4542",
    strokeWidth: 0.923077
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 171.832,
    cy: 215.343,
    rx: 1.91906,
    ry: 2.55875,
    fill: "#5B4542"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 182.067,
    cy: 215.344,
    rx: 1.91906,
    ry: 2.55875,
    fill: "#5B4542"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_5003_9813)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 153.278,
    cy: 161.611,
    r: 11.5144,
    fill: "url(#paint4_linear_5003_9813)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 153.278,
    cy: 161.611,
    r: 11.0528,
    stroke: "#5B4542",
    strokeWidth: 0.923077
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 138.292,
    y: 201.271,
    width: 13.0778,
    height: 3.01795,
    rx: 1.50897,
    transform: "rotate(90 138.292 201.271)",
    fill: "#5B4542"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -0.461538,
    y: 0.461538,
    width: 8.30769,
    height: 84.9231,
    rx: 4.15385,
    transform: "matrix(-1 0 0 1 420 146.405)",
    fill: "white",
    stroke: "#5B4542",
    strokeWidth: 0.923077
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M470.769 111.298C470.769 92.4518 455.491 77.1737 436.645 77.1737H377.539V149.025C377.539 152.166 380.085 154.712 383.226 154.712H465.082C468.223 154.712 470.769 152.166 470.769 149.025V111.298Z",
    fill: "url(#paint5_linear_5003_9813)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M405.692 105.328C405.692 90.0335 393.294 77.6353 378 77.6353C362.706 77.6353 350.308 90.0335 350.308 105.328V154.251H405.692V105.328Z",
    fill: "white",
    stroke: "#5B4542",
    strokeWidth: 0.923077
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M405.483 154.251L395.633 179.932L395.629 179.942L395.626 179.952L394.661 182.865C390.097 196.642 377.218 205.943 362.705 205.943H359.832H359.421C346.07 205.943 336.555 192.987 340.546 180.249L350.518 154.251H405.483Z",
    fill: "#FED4C7",
    stroke: "#5B4542",
    strokeWidth: 0.923077
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 422.769,
    y: 68.8661,
    width: 1.84615,
    height: 8.30769,
    fill: "#5B4542"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M427.227 53.8165C423.741 53.0222 420.832 54.8289 419.72 56.0944C411.379 61.6622 411.378 68.242 412.213 70.5199C425.557 71.2792 433.064 65.2067 433.064 60.649C433.064 56.0913 430.562 54.5764 427.227 53.8165Z",
    fill: "#FED4C7"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M433.066 51.5017C433.066 50.6536 430.239 49.7347 428.826 49.3813L426.705 52.5619C428.826 52.5619 433.066 52.3499 433.066 51.5017Z",
    fill: "#5B4542"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 424.584,
    cy: 49.3811,
    r: 5.89969,
    fill: "white",
    stroke: "#5B4542",
    strokeWidth: 0.923077
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M409.755 61.2126C412.938 53.204 420.466 52.2568 422.61 53.4639C428.775 57.471 421.487 62.5856 417.073 64.642C410.448 67.7233 406.571 69.2212 409.755 61.2126Z",
    fill: "#90D0DE"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 427.765,
    cy: 48.3209,
    r: 1.0602,
    fill: "#5B4542"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M378 77.1737C393.549 77.1737 406.154 89.8083 406.154 105.394V137.174L393.536 129.82L385.311 125.24C379.828 122.034 373.887 118.828 367.947 115.647C365.662 114.248 364.292 113.332 362.007 111.983L349.846 105.394C349.846 89.8083 362.451 77.1737 378 77.1737Z",
    fill: "#5B4542"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3077 27.9349C21.911 22.858 28.9652 13.6661 44.3563 17.5139C44.3563 12.1697 47.2713 4.09544 59.077 1.94298C71.7328 -0.364495 79.6276 7.89441 80.4292 11.1009C83.9029 8.96324 92.7741 5.8102 100.47 10.2993C108.165 14.7883 109.02 22.3236 108.486 25.53C113.83 20.4531 127.725 13.8264 140.551 27.9349",
    stroke: "#5B4542",
    strokeWidth: 1.60324,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8822 29.9025C48.7526 27.7649 54.0968 23.8102 60.5097 25.0928C66.9227 26.3754 70.1292 31.5058 70.9308 33.9107C73.3356 31.773 79.9089 28.9406 86.9632 34.7123",
    stroke: "#5B4542",
    strokeWidth: 1.60324,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M323.077 150.097H328.615",
    stroke: "#5B4542",
    strokeWidth: 0.923077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M325.846 143.635H335.077",
    stroke: "#5B4542",
    strokeWidth: 0.923077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M327.692 137.174H338.769",
    stroke: "#5B4542",
    strokeWidth: 0.923077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M335.226 45.5411C338.76 45.2491 341.537 42.2884 341.537 38.6791C341.537 34.8762 338.454 31.7934 334.651 31.7934C333.848 31.7934 333.077 31.9308 332.361 32.1833C330.985 28.2793 327.263 25.4814 322.888 25.4814C319.841 25.4814 317.111 26.8389 315.269 28.9822C314.945 28.9439 314.616 28.9242 314.282 28.9242C310.71 28.9242 307.664 31.1749 306.484 34.3355C305.956 34.175 305.395 34.0887 304.814 34.0887C301.645 34.0887 299.076 36.6578 299.076 39.8268C299.076 42.9958 301.645 45.5648 304.814 45.5648C304.831 45.5648 304.848 45.5648 304.865 45.5646H334.61C334.624 45.5647 334.637 45.5647 334.651 45.5647C334.665 45.5647 334.678 45.5647 334.692 45.5646H335.226V45.5411Z",
    fill: "#DEF1F9"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M428.269 238.712H415.225C415.221 238.712 415.218 238.712 415.214 238.712C415.21 238.712 415.207 238.712 415.203 238.712H397.379C397.376 238.712 397.374 238.712 397.372 238.712C397.37 238.712 397.368 238.712 397.366 238.712H396.502V238.676C391.141 238.234 386.928 233.743 386.928 228.268C386.928 222.5 391.604 217.824 397.372 217.824C398.59 217.824 399.759 218.033 400.846 218.416C402.933 212.494 408.578 208.251 415.214 208.251C419.836 208.251 423.978 210.31 426.771 213.561C427.262 213.503 427.762 213.473 428.269 213.473C433.686 213.473 438.307 216.886 440.096 221.68C440.897 221.437 441.748 221.306 442.629 221.306C447.436 221.306 451.333 225.202 451.333 230.009C451.333 234.816 447.436 238.712 442.629 238.712C442.627 238.712 442.625 238.712 442.623 238.712H428.269Z",
    fill: "#90D0DE"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 380.638,
    cy: 224.536,
    r: 4.02231,
    fill: "#90D0DE"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 397.808,
    cy: 212.167,
    r: 3.04615,
    fill: "#90D0DE"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 410.428,
    cy: 220.435,
    r: 2.61099,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 396.937,
    cy: 229.574,
    r: 2.17582,
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 423.482,
    cy: 232.567,
    r: 2.61099,
    fill: "white"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 430.009,
    cy: 220.053,
    r: 2.17582,
    fill: "white"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 443.065,
    cy: 226.963,
    r: 2.17582,
    fill: "white"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 458.676,
    cy: 226.093,
    r: 4.31191,
    fill: "#90D0DE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5003_9813",
    x: 139.643,
    y: 170.569,
    width: 27.2714,
    height: 37.3605,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 11.0769,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_5003_9813"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 14.7692
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.0769
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.3 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5003_9813"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5003_9813",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_5003_9813",
    x: 130.686,
    y: 150.097,
    width: 45.1827,
    height: 48.8749,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 11.0769,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_5003_9813"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 14.7692
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.0769
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.3 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5003_9813"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5003_9813",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5003_9813",
    x1: 16.3204,
    y1: 117.017,
    x2: 145.891,
    y2: 124.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0105708,
    stopColor: "#FF8A79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA471"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5003_9813",
    x1: 200.308,
    y1: 146.039,
    x2: 267.107,
    y2: 148.198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0105708,
    stopColor: "#FF8A79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA471"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5003_9813",
    x1: 295.847,
    y1: 138.097,
    x2: 295.847,
    y2: 148.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5003_9813",
    x1: 150.72,
    y1: 170.928,
    x2: 156.066,
    y2: 171.056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0105708,
    stopColor: "#FF7C6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA16C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5003_9813",
    x1: 141.763,
    y1: 150.816,
    x2: 165.767,
    y2: 152.107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0105708,
    stopColor: "#FF7C6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA16C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5003_9813",
    x1: 436.154,
    y1: 154.712,
    x2: 427.762,
    y2: 77.2328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA471"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThirdPartyBanner);
export default __webpack_public_path__ + "static/media/third-party-banner.b6d0c0116ad6e7dc29da7ec9b3ebf449.svg";
export { ForwardRef as ReactComponent };